
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetoshirdibushire() {



    const cardData =
    {
        keyword: 'Pune to Shirdi Bus Hire',
        heading: 'Amruta Travels: Pune to Shirdi Bus Hire',
        headingDescription: 'Amruta Travels offers Pune to Shirdi Bus Hire, providing a reliable and comfortable transportation solution for pilgrims and travelers. Whether you are planning a spiritual journey, a family trip, or a group tour, our well-maintained buses ensure a smooth and enjoyable ride to Shirdi. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, we make your travel to Shirdi simple and stress-free. Choose from our range of buses, including 25-seater, 32-seater, and 50-seater options, to suit your group size. Book your Pune to Shirdi Bus with Amruta Travels and embark on a journey of comfort and devotion!',


        top: 'Top Places to Visit in Shirdi with Amruta Travels',

       "topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "The heart of Shirdi, this sacred temple is dedicated to Sai Baba, the revered spiritual leader. Devotees from across the globe visit to seek blessings and experience peace. The temple complex includes the Samadhi Mandir, Dwarkamai, Chavadi, and Gurusthan."
  },
  {
    "title": "Dwarkamai",
    "description": "Located next to the Sai Baba Temple, Dwarkamai is a mosque where Sai Baba spent a significant portion of his life. It houses a sacred stone where Baba sat and a perpetual dhuni (sacred fire) believed to grant blessings."
  },
  {
    "title": "Chavadi",
    "description": "This historic building is where Sai Baba rested every alternate night. Today, it stands as a place of devotion with a beautifully preserved palkhi (palanquin) and Baba’s belongings. Processions still take place every Thursday night."
  },
  {
    "title": "Sai Heritage Village",
    "description": "An open-air museum and theme park, Sai Heritage Village portrays life during Sai Baba’s time. It features life-size statues, recreated scenes, and traditional village setups — making it both educational and devotional."
  },
  {
    "title": "Gurusthan",
    "description": "Believed to be the spot where Sai Baba first appeared in Shirdi, Gurusthan has a neem tree and a shrine. Devotees light incense sticks here for spiritual healing and blessings."
  },
  {
    "title": "Lendi Baug",
    "description": "A serene garden once tended by Sai Baba himself, Lendi Baug contains a lamp lit by Baba and a beautiful walking path. It’s a peaceful spot ideal for quiet reflection."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Located near the temple area, this family-friendly water park offers a fun break with thrilling rides, slides, and wave pools — perfect for those traveling with children or groups."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Around 70 km from Shirdi, this unique village is famous for its open-door houses and the temple of Lord Shani. It’s a popular one-day trip from Shirdi for devotees and spiritual seekers."
  },
  {
    "title": "Khandoba Mandir",
    "description": "Situated near the main temple, this small yet significant shrine is where Sai Baba was first welcomed by the local priest upon his arrival in Shirdi. It holds a special place in Sai Baba’s story."
  },
  {
    "title": "House of Laxmibai Shinde",
    "description": "This simple house belonged to one of Sai Baba’s closest devotees. It now serves as a small museum displaying items used by Baba and letters written by him — offering an intimate glimpse into his life."
  }
],

       "services": [
    {
      "name": "Pune to Shirdi Bus Package",
      "description": "Amruta Travels offers the best Pune to Shirdi bus package for a seamless, comfortable pilgrimage experience. Our buses are well-equipped with all amenities, and we ensure safe, timely transportation for all devotees. Join us for a memorable Shirdi Darshan with personalized services."
    },
    {
      "name": "Pune to Shirdi Bus Package (One Day)",
      "description": "Book a one-day Pune to Shirdi bus package with Amruta Travels for a hassle-free, divine experience. Our buses are comfortable, and we ensure timely departures and arrivals, making it an ideal option for those looking for a quick but memorable trip to Shirdi."
    },
    {
      "name": "Pune to Shirdi One Day Package by Bus",
      "description": "If you're looking for a one-day trip to Shirdi from Pune, Amruta Travels offers the perfect solution. Our one-day bus package ensures comfort, convenience, and religious satisfaction as we provide an expert-guided tour and ensure you get the most out of your day."
    },
    {
      "name": "Pune to Shirdi Tour Package by Bus",
      "description": "Experience a full day of devotion and comfort with Amruta Travels' Pune to Shirdi tour package by bus. From departure to return, we ensure a smooth, comfortable, and punctual journey with well-maintained buses, knowledgeable drivers, and dedicated service."
    },
    {
      "name": "Shirdi Darshan Bus From Pune",
      "description": "Book a Shirdi Darshan bus from Pune with Amruta Travels for a spiritual journey that’s safe and comfortable. We offer well-planned trips with experienced drivers, ensuring you get to the temple on time and back with peace of mind."
    },
    {
      "name": "Shirdi Package from Pune by Bus",
      "description": "Plan a Shirdi package from Pune by bus with Amruta Travels, offering flexible schedules, safe rides, and cost-effective travel. Whether you're going solo, with family, or in a group, our buses ensure you enjoy a stress-free trip."
    },
    {
      "name": "Pimpri Chinchwad to Shirdi Bus on Rent",
      "description": "Amruta Travels offers bus rental services from Pimpri Chinchwad to Shirdi for pilgrims and groups. We provide a comfortable, reliable, and punctual journey with well-maintained buses, ensuring that your spiritual journey is pleasant."
    },
    {
      "name": "Pune to Shani Shingnapur Bus Packages",
      "description": "Combine your Shirdi Darshan with a visit to Shani Shingnapur with Amruta Travels' exclusive bus packages. Our Pune to Shani Shingnapur bus service provides comfort, safety, and flexibility, making it an ideal pilgrimage tour."
    },
    {
      "name": "Pune to Shirdi One Day Package by Bus",
      "description": "Experience the perfect one-day trip from Pune to Shirdi with Amruta Travels. This package includes timely departure, clean and comfortable buses, and a well-organized trip to ensure you make the most of your visit to Shirdi."
    },
    {
      "name": "Bus on Rent in Kothrud Pune",
      "description": "Amruta Travels offers buses for rent in Kothrud, Pune for local or outstation trips. Whether you're going to Shirdi or another destination, we provide safe, comfortable, and affordable transportation for all group sizes."
    },
    {
      "name": "Bus on Rent in Sinhagad Road Pune",
      "description": "If you're looking for bus rentals in Sinhagad Road, Pune, Amruta Travels offers a range of options for your travel needs. From family trips to group pilgrimages, our buses are well-maintained and offer a comfortable ride."
    },
    {
      "name": "Pune to Ajanta Ellora Tour Bus Package",
      "description": "Take a trip to the historical Ajanta Ellora caves with Amruta Travels' Pune to Ajanta Ellora tour bus package. Our buses ensure you travel in comfort, with expert drivers and a relaxed journey to one of Maharashtra's most famous UNESCO World Heritage sites."
    },
    {
      "name": "Bus Hire for Pune to Shirdi",
      "description": "Rent a bus for your group from Pune to Shirdi with Amruta Travels. Our comfortable buses, professional drivers, and dedicated services ensure that you have a smooth, enjoyable journey to one of India's most revered religious sites."
    },
    {
      "name": "Pune to Shirdi Bus Rentals",
      "description": "Amruta Travels offers flexible Pune to Shirdi bus rentals for groups of all sizes. Whether it's a family trip, a pilgrimage, or a corporate outing, we provide buses with air conditioning, ample seating, and a professional driver to make your journey comfortable."
    },
    {
      "name": "Hire a Bus from Pune to Shirdi",
      "description": "Hiring a bus from Pune to Shirdi with Amruta Travels guarantees a comfortable, hassle-free experience. We offer buses equipped with AC, ample legroom, and clean interiors for a smooth journey to Shirdi."
    },
    {
      "name": "Pune to Shirdi Tour Bus Rental",
      "description": "Make your pilgrimage to Shirdi even more special with Amruta Travels' Pune to Shirdi tour bus rental service. We ensure timely arrivals, clean buses, and experienced drivers for a smooth and comfortable journey."
    },
    {
      "name": "Pune to Shirdi Family Trip Bus Hire",
      "description": "Book a bus for your family trip from Pune to Shirdi with Amruta Travels. Our spacious and comfortable buses ensure that your entire family travels comfortably with professional drivers and expert services."
    },
    {
      "name": "Pune to Shirdi Weekend Getaway Bus Rental",
      "description": "Looking for a weekend getaway? Book a bus with Amruta Travels for a comfortable and relaxing journey from Pune to Shirdi. Our weekend getaway package offers timely departures, comfortable buses, and a peaceful journey."
    },
    {
      "name": "Pune to Shirdi Corporate Bus Hire",
      "description": "Amruta Travels offers corporate bus hire services from Pune to Shirdi. Ideal for team trips or corporate outings, our buses ensure comfort, safety, and punctuality, making sure your group has an efficient and relaxing journey."
    },
    {
      "name": "Pune to Shirdi Group Travel Bus Rental",
      "description": "Book a 50-seater or 32-seater bus for group travel from Pune to Shirdi with Amruta Travels. Our group travel bus rental service ensures comfort, punctuality, and a pleasant journey for all passengers."
    },
    {
      "name": "AC Bus Hire Pune to Shirdi",
      "description": "Travel in comfort with Amruta Travels' AC bus hire service from Pune to Shirdi. Our buses are equipped with air conditioning, ensuring you travel cool and relaxed on your journey to Shirdi."
    },
    {
      "name": "Comfortable Bus from Pune to Shirdi",
      "description": "Choose Amruta Travels for a comfortable journey from Pune to Shirdi. Our buses are designed for maximum comfort, featuring comfortable seating, air conditioning, and experienced drivers to ensure a smooth trip."
    },
    {
      "name": "25-Seater Bus Hire Pune to Shirdi",
      "description": "If you’re looking for a smaller group travel option, Amruta Travels offers 25-seater bus hire from Pune to Shirdi. Our compact buses ensure a comfortable journey for smaller groups, with professional drivers ensuring safety and punctuality."
    },
    {
      "name": "32-Seater Bus Hire from Pune to Shirdi",
      "description": "Book a 32-seater bus with Amruta Travels for your group travel from Pune to Shirdi. We provide a comfortable, reliable, and safe bus service, perfect for families, friends, or religious groups traveling to Shirdi."
    },
    {
      "name": "50 Seater Bus Hire from Pune to Shirdi",
      "description": "Amruta Travels offers 50-seater bus hire from Pune to Shirdi, making it an ideal option for larger groups. Our spacious buses provide maximum comfort, and our professional drivers ensure a smooth and safe journey to Shirdi."
    }
  ],
  "tableData": [
    ["Pune to Shirdi Bus Package", "Pune to Shirdi Bus Package (One Day)"],
    ["Pune to Shirdi One Day Package by Bus", "Pune to Shirdi Tour Package by Bus"],
    ["Shirdi Darshan Bus From Pune", "Shirdi Package from Pune by Bus"],
    ["Pimpri Chinchwad to Shirdi Bus on Rent", "Pune to Shani Shingnapur Bus Packages"],
    ["Pune to Shirdi One Day Package by Bus", "Bus on Rent in Kothrud Pune"],
    ["Bus on Rent in Sinhagad Road Pune", "Pune to Ajanta Ellora Tour Bus Package"],
    ["Bus Hire for Pune to Shirdi", "Pune to Shirdi Bus Rentals"],
    ["Hire a Bus from Pune to Shirdi", "Pune to Shirdi Tour Bus Rental"],
    ["Pune to Shirdi Family Trip Bus Hire", "Pune to Shirdi Weekend Getaway Bus Rental"],
    ["Pune to Shirdi Corporate Bus Hire", "Pune to Shirdi Group Travel Bus Rental"],
    ["AC Bus Hire Pune to Shirdi", "Comfortable Bus from Pune to Shirdi"],
    ["25-Seater Bus Hire Pune to Shirdi", "32-Seater Bus Hire from Pune to Shirdi"],
    ["50 Seater Bus Hire from Pune to Shirdi", ""]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Relaxing Journey",
    "WhyChoosedescription": "Amruta Travels offers Pune to Shirdi Bus Hire services with spacious seating, air conditioning, and ample legroom. Enjoy a comfortable ride during your pilgrimage or leisure trip to Shirdi."
  },
  {
    "WhyChooseheading": "Perfect for Pilgrimages and Group Travel",
    "WhyChoosedescription": "Whether you’re planning a religious pilgrimage, family outing, or group tour, our Pune to Shirdi buses are ideal for all kinds of group travel with reliable and smooth transportation."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our professional drivers are well-versed with the Pune to Shirdi route, ensuring a safe and timely journey. They are courteous, punctual, and committed to your comfort and safety."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Amruta Travels provides Pune to Shirdi Bus Hire at budget-friendly rates. Our transparent pricing ensures no hidden costs, giving you confidence and clarity when planning your trip."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Buses",
    "WhyChoosedescription": "We maintain high standards of hygiene and regularly service our buses for optimal performance. Travel in clean, sanitized, and well-kept vehicles for a worry-free experience."
  },
  {
    "WhyChooseheading": "Round-the-Clock Availability",
    "WhyChoosedescription": "Our Pune to Shirdi Bus Hire service is available 24/7 to accommodate early morning departures or late-night returns. We provide flexible scheduling to match your itinerary."
  },
  {
    "WhyChooseheading": "Customizable Itineraries",
    "WhyChoosedescription": "Need multiple pick-up points or stopovers along the way? We customize the travel plan based on your group’s needs for a personalized and convenient journey."
  },
  {
    "WhyChooseheading": "Easy Booking and Reliable Support",
    "WhyChoosedescription": "Booking Pune to Shirdi Bus Hire with Amruta Travels is simple and efficient. Our online platform, customer support team, and office are available to assist you every step of the way."
  }
]
























    }

const faqData = [
  {
    question: 'How can I hire a bus from Pune to Shirdi with Amruta Travels?',
    answer: 'Hiring a bus for the Pune to Shirdi journey with Amruta Travels is easy. You can book online, call our support team, or visit our office. We’ll assist you with your booking, ensuring a comfortable and hassle-free trip.',
  },
  {
    question: 'What types of buses are available for Pune to Shirdi trips?',
    answer: 'We offer a variety of buses for the Pune to Shirdi trip, including 32, 35, 45, and 50 seater options. All our buses are comfortable, air-conditioned, and equipped with ample space for luggage.',
  },
  {
    question: 'Is the bus hire for Pune to Shirdi available for both one-way and round trips?',
    answer: 'Yes, we provide flexible options for both one-way and round trips from Pune to Shirdi. Whether you need a quick day trip or an extended stay, we can accommodate your travel needs.',
  },
  {
    question: 'Are the buses well-maintained and sanitized for the Pune to Shirdi trip?',
    answer: 'Yes, all our buses are well-maintained and sanitized before each trip to ensure cleanliness, safety, and comfort for your journey from Pune to Shirdi.',
  },
  {
    question: 'How much does it cost to hire a bus from Pune to Shirdi?',
    answer: 'The cost depends on the bus type, trip duration, and specific requirements for your journey. Please contact us for a custom quote based on your travel details.',
  },
  {
    question: 'Can I request multiple pickup and drop-off locations for Pune to Shirdi?',
    answer: 'Yes, we can arrange multiple pickup and drop-off points for your convenience. Just provide us with the details of your itinerary and we’ll customize the route accordingly.',
  },
  {
    question: 'Do you provide drivers with the bus for the Pune to Shirdi journey?',
    answer: 'Yes, every bus hire from Pune to Shirdi comes with an experienced, licensed driver to ensure a safe, smooth, and timely journey.',
  },
  {
    question: 'Is the bus hire for Pune to Shirdi available for group tours?',
    answer: 'Absolutely! Our buses are perfect for group tours from Pune to Shirdi. Whether it’s a family trip, religious pilgrimage, or corporate group, we’ve got you covered.',
  },
  {
    question: 'Why choose Amruta Travels for Pune to Shirdi bus hire?',
    answer: 'Amruta Travels offers reliable service with clean buses, experienced drivers, and a focus on customer comfort. We prioritize punctuality, safety, and a hassle-free travel experience for your Pune to Shirdi trip.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ravi Patil',
    role: 'Pilgrim, Pune',
    text: 'We hired a 32-seater bus from Amruta Travels for our group trip to Shirdi. The bus was comfortable, and the driver was experienced and courteous. The journey was smooth and enjoyable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Priya Shah',
    role: 'Group Travel Organizer, Pune',
    text: 'Amruta Travels provided us with a 45-seater bus for our family trip to Shirdi. The bus was on time, clean, and well-maintained. The entire experience was seamless, and we would highly recommend them.',
    rating: 5,
  },
];




































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Bus Hire",
  "image": "https://bushireinpune.com/assets/images/pune-to-shirdi-bus.jpg",
  "description": "Book a comfortable and affordable Pune to Shirdi bus hire with Amruta Travels. Choose from 25, 32, and 50-seater buses for a smooth and safe journey. Enjoy customized one-day packages, family trips, and corporate group travel options. AC and Non-AC buses available for Shirdi Darshan and weekend getaways.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4925"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "42", // price per km or package can be adjusted based on the service
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-shirdi-bus-hire"
  }
};





    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Pune to Shirdi Bus Hire | One Day Package, Family Trip & Corporate Travel | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book your Pune to Shirdi bus hire with Amruta Travels. Choose from 25, 32, and 50-seater buses for Shirdi Darshan, family trips, weekend getaways, and corporate events. AC & Non-AC options available." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/8.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoshirdibushire;